import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

export interface IReversalAmountValidation {
    /** Valid amount (2 decimals) or null */
    amount: number | null;
    /** Message to show the user; null when valid or still empty */
    error: string | null;
}

/**
 * Validates a typed reversal amount against the limit
 * @param raw value typed by the user (accepts "." or "," as decimal separator)
 * @param max amount available for the campaign
 */
export function validateReversalAmount(raw: any, max: number): IReversalAmountValidation {

    const text = String(raw ?? '').trim().replace(',', '.');

    if (!text) return { amount: null, error: null };

    const amount = Number(text);

    if (!isFinite(amount) || amount <= 0)
        return { amount: null, error: 'Indique um valor superior a 0.' };

    // work in cents to avoid floating point errors (e.g. 0.1 + 0.2)
    const cents = Math.round(amount * 100);

    if (Math.abs(cents - amount * 100) > 1e-6)
        return { amount: null, error: 'Utilize no máximo 2 casas decimais.' };

    if (cents > Math.round(max * 100))
        return { amount: null, error: `O valor não pode ser superior a ${max.toFixed(2)} €.` };

    return { amount: cents / 100, error: null };
}

@Component({
    selector: 'app-balance-reversal',
    templateUrl: './balance-reversal.component.html',
    styleUrls: ['./balance-reversal.component.scss'],
})
export class BalanceReversalModalComponent {

    public CampaignName: string = '';
    public MaxAmount: number = 0;
    /** 'reversal' (default, wallet -> bank account) or 'transfer' (SIBS, campaign -> client wallet balance) */
    public Mode: 'reversal' | 'transfer' = 'reversal';

    public Amount: FormControl = new FormControl('');

    constructor(
        private ModalController: ModalController,
        private NavParams: NavParams
    ) {
        this.Mode = this.NavParams.get('mode') || this.Mode;
        this.CampaignName = this.NavParams.get('campaignName') || this.CampaignName;
        this.MaxAmount = this.NavParams.get('maxAmount') || this.MaxAmount;
    }

    get Validation(): IReversalAmountValidation {
        return validateReversalAmount(this.Amount.value, this.MaxAmount);
    }

    public OnUseMax() {
        this.Amount.setValue(this.MaxAmount.toFixed(2));
        this.Amount.markAsDirty();
    }

    public Close() {
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }

    public OnConfirm() {

        const { amount } = this.Validation;

        if (amount === null) return;

        this.ModalController.dismiss({ amount }, EnumGenericRoleActionAlerts.Confirm);
    }
}
